module.exports = __webpack_public_path__ + "img/zz1.ba18d6cf.png";